import type { Proposal } from '@/services/proposals/types';
import { BrokerInactiveNotice } from '@/features/brokers/components/broker-inactive-notice.component';
import { useSelectedBrokerWriteGuard } from '@/features/brokers/hooks';
import { Page, PageHeader } from '@/shared/ui/page';
import { Home } from 'lucide-react';
import { NewCapitalGlobalProposalForm } from './new-capital-global-proposal-form.component';

type Props = {
  proposal: Proposal;
  policyId: string;
  mode: 'edit' | 'view';
};

export function NewCapitalGlobalProposalLayout({
  proposal,
  policyId,
  mode,
}: Props) {
  const proposalNoLabel = proposal.proposalNo
    ? String(proposal.proposalNo)
    : 'XXXX';
  const proposalActionGuard = useSelectedBrokerWriteGuard('proposal', 'other');

  return (
    <>
      <Page.Breadcrumb
        items={[
          {
            label: 'Página Inicial',
            href: '/dashboard',
            iconLeft: <Home className='h-4 w-4' />,
          },
          { label: 'Comercial' },
          { label: 'Propostas', href: '/proposals' },
          { label: 'Proposta', active: true },
        ]}
      />
      <PageHeader.Root>
        <PageHeader.Main>
          <PageHeader.TitleGroup>
            <PageHeader.Title>
              Proposta Capital Global - Nº {proposalNoLabel}
            </PageHeader.Title>
            <PageHeader.Subtitle>
              Preencha as informações para efetuar a Proposta
            </PageHeader.Subtitle>
          </PageHeader.TitleGroup>
        </PageHeader.Main>
      </PageHeader.Root>
      <BrokerInactiveNotice guards={[proposalActionGuard]} />
      <Page.Content className='py-4'>
        <NewCapitalGlobalProposalForm
          proposal={proposal}
          policyId={policyId}
          mode={mode}
        />
      </Page.Content>
    </>
  );
}
